import { RouterReducerState } from '../../interfaces';
import {
  DecrementStackAction,
  DECREMENT_STACK,
  IncrementStackAction,
  INCREMENT_STACK,
  ResetStackAction,
  RESET_STACK,
  SetBackgroundLocationAction,
  SetIsTransitioningAction,
  SET_BACKGROUND_LOCATION,
  SET_IS_TRANSITIONING,
} from './actions';

type RouterActions =
  | SetBackgroundLocationAction
  | SetIsTransitioningAction
  | IncrementStackAction
  | DecrementStackAction
  | ResetStackAction;

const initialRouterState: RouterReducerState = {
  background: undefined,
  isTransitioning: false,
  stack: 0,
};

export const routerReducer = (state: RouterReducerState = initialRouterState, action: RouterActions) => {
  switch (action.type) {
    case SET_BACKGROUND_LOCATION:
      return {
        ...state,
        background: action.background,
        isTransitioning: false,
      };
    case SET_IS_TRANSITIONING:
      return {
        ...state,
        isTransitioning: action.isTransitioning,
      };
    case INCREMENT_STACK:
      return {
        ...state,
        stack: state.stack + 1,
      };
    case DECREMENT_STACK:
      return {
        ...state,
        stack: state.stack - 1,
      };
    case RESET_STACK:
      return {
        ...state,
        stack: 0,
      };

    default:
      return state;
  }
};
